import { FormattedMessage } from 'react-intl';

import { useTheme } from '../../contexts/ThemeContext';

interface LiveQuestionMessageProps {
    isWaiting: boolean;
    isAnswering: boolean;
    isAnswered: boolean;
    isValid: boolean;
    isInvalid: boolean;
    isEnded: boolean;
    isPreview: boolean;
    body: string;
}

function LiveQuestionMessage({
    isWaiting,
    isAnswering,
    isAnswered,
    isValid,
    isInvalid,
    isEnded,
    isPreview,
    body,
}: LiveQuestionMessageProps) {
    const { name: theme = null } = useTheme();

    const successMessage =
        theme === 'defis' ? (
            <FormattedMessage defaultMessage="Bravo!" description="Question label" />
        ) : (
            <FormattedMessage
                defaultMessage="You're perfectly right!"
                description="Question label"
            />
        );

    const failedMessage =
        theme === 'defis' ? (
            <FormattedMessage
                defaultMessage="Better luck next time!"
                description="Question label"
            />
        ) : (
            <FormattedMessage
                defaultMessage="Sorry!{br}The perfect answer is:"
                description="Question label"
                values={{ br: <br /> }}
            />
        );

    if (isWaiting) {
        return (
            <FormattedMessage
                defaultMessage="Waiting for next question..."
                description="Question message"
            />
        );
    } else if (isAnswering) {
        return body;
    } else if (isAnswered && !isEnded) {
        return (
            <FormattedMessage
                defaultMessage="Waiting for other participants to answer..."
                description="Question label"
            />
        );
    } else if (isValid && !isPreview) {
        return successMessage;
    } else if (isInvalid && !isPreview) {
        return failedMessage;
    } else if (isEnded) {
        return <FormattedMessage defaultMessage="The answer is: " description="Question label" />;
    }

    return null;
}

export default LiveQuestionMessage;
